/* eslint-disable @typescript-eslint/naming-convention */
import { InjectionToken } from '@angular/core';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IBrandigApiProps } from '@boxx/dynamic-branding/lib/services/dynamic-branding-service';
import { EcwidModel } from '@boxx/store-core/lib/models/Ecwid.model';
import { Observable } from 'rxjs';
import {
  ConfigNotificationsDataProps,
  OnboardingBusinessConfigPaymentsDataProps,
  OnboardingBusinessConfigScheduleDataProps,
  OnboardingBusinessConfigServicesDataProps,
} from '../models/BusinessConfig.model';
import {
  BusinessGetApiRespProps,
  BusinessSiteFields,
  BusinessUpdateApiRespProps,
  BusinessUpdatePayloadProps,
  ICreateUserProps,
  IDeleteImageFormProps,
  IDeleteImageResponse,
  IGetBusinessImagesApiRespoProps,
  IGetSiteImagesProps,
  ISearchClientResponse,
  IWizardCreateUserApiRespProps,
  IWizardCreateUserPayloadProps,
  IWizardUserBusinessAdditionalInfoResponse,
  IWizardUserBusinessInfoResponse,
  IWizardUserPersonalInfoResponse,
  WizardGetTemplatesApiRespProps,
} from './IOnboarding.api';

export interface IOnboardingRepository {
  getBusinessData(): Observable<JsonApiResponse<BusinessGetApiRespProps>>;

  getTemplates(
    query: string
  ): Observable<JsonApiResponse<WizardGetTemplatesApiRespProps>>;

  getSiteFields(): Observable<JsonApiResponse<BusinessSiteFields>>;
  getSiteFieldsByLanguage(lng: string): Observable<JsonApiResponse<BusinessSiteFields>>;

  updateSiteFields(payload: BusinessSiteFields): Observable<JsonApiResponse<any>>;

  getImagesData(): Observable<JsonApiResponse<IGetBusinessImagesApiRespoProps>>;

  getSiteImages (): Observable<JsonApiResponse<IGetSiteImagesProps>>;
  createDirectory (): Observable<JsonApiResponse<any>>;
  
  getUploadImagesUrl(): string;
  verifySubscriptionStatus(brand_id: any, subscription_id: any): Observable<JsonApiResponse<any>>;
  getColorThemes(): Observable<JsonApiResponse<any>>;
  getPanelLink(): Observable<JsonApiResponse<any>>;
  
  updateSiteFieldsEnglish(payload: any): Observable<JsonApiResponse<any>> ;
  getLawDocuments(brandId, language, type): Observable<JsonApiResponse<any>>;
  deleteBusinesImage(
    payload: IDeleteImageFormProps
  ): Observable<JsonApiResponse<IDeleteImageResponse>>;

  uploadImageData(payload: IImageFormProps): Observable<JsonApiResponse<any>>;
  
  getConfigNotifications (): Observable<JsonApiResponse<any>>;

  validateUser(
    payload: any
  ): Observable<JsonApiResponse<any>>;

  getAssociations(): Observable<JsonApiResponse<any>>;
  
  validatePayment(brand_id: number, id: string): Observable<JsonApiResponse<any>>;

  createHostedPage(
    payload: any
  ): Observable<JsonApiResponse<any>>;
  createHostedPageShipping(
    payload: any
  ): Observable<JsonApiResponse<any>>;
  getItemPrices(brandId: number): Observable<any>;
  
  saveUserFormDataMeed(
    payload: FormData
  ): Observable<any>;

  updateConfigNotifications(
    payload: FormData
  ): Observable<any>;

  validaZipcode(zipcode: number): Observable<any>;

  // ------------- REGISTRATION-------------
  saveUserData(
    payload: IWizardCreateUserPayloadProps
  ): Observable<JsonApiResponse<IWizardCreateUserApiRespProps>>;
  
   // ------------- NOTIFICATIONS-------------
  updateNotificationsData(
    payload: any
  ): Observable<JsonApiResponse<any>>;

  createSchedulingLink(): Observable<JsonApiResponse<any>>;
  validateSchedulingLink(): Observable<JsonApiResponse<any>>;

  sendResetCode(params: any): Observable<JsonApiResponse<any>>;
  validateCode(params: any): Observable<JsonApiResponse<any>>;
  updatePassword(params: any): Observable<JsonApiResponse<any>>;
  
  getNotificationsSettings(): Observable<ConfigNotificationsDataProps>;

  registerTelmex(
    payload: any
  ): Observable<JsonApiResponse<any>>;

  // ------------- BUSINESS CONFIG -------------
  updateBusinessData(
    payload: BusinessUpdatePayloadProps
  ): Observable<JsonApiResponse<BusinessUpdateApiRespProps>>;

  updateBusinessInfoData(
    payload: IBusinessUpdateInfoPayload
  ): Observable<JsonApiResponse<BusinessUpdateApiRespProps>>;

  saveScoreData(
    payload: IRatingAppProps
  ): Observable<JsonApiResponse<BusinessUpdateApiRespProps>>;

  setTokenEcwid(payload: ITokenEcwid): Observable<IHttpBasicResponse<EcwidModel>>;

  createWebsite(): Observable<JsonApiResponse<any>>;

  updateMeta(
    payload: UpdateMetaPayloadProps
  ): Promise<JsonApiResponse<BusinessUpdateApiRespProps>>;

  // ------------- BOOKING-------------
  getBookingServices(): Observable<any>;

  //------ UTILS -------
  getWizardUserPersonalInfo(
    businessId: number
  ): Observable<IWizardUserPersonalInfoResponse>;
  getWizardBusinessInfo(
    businessId: number
  ): Observable<IWizardUserBusinessInfoResponse>;
  getWizardBusinessAdditionalInfo(
    businessId: number
  ): Observable<IWizardUserBusinessAdditionalInfoResponse>;
  searchClient(
    email: string
  ): Observable<JsonApiResponse<ISearchClientResponse | undefined>>;
  validationCode(code: string): Observable<JsonApiResponse<IBrandigApiProps>>; 

  getSearchByZipcode(zipcode: number): Observable<any>;
  getStates(): Observable<any>;
  getLocalities(state: number): Observable<any>;
  getSettlements(locality: number): Observable<any>;

  //Redesign:
  registerUser(
    payload: ICreateUserProps
  ): Observable<JsonApiResponse<IWizardCreateUserApiRespProps>>;

  validateEmail(
    payload: any
  ): Observable<JsonApiResponse<any>>;

}
export const ONBOARDING_REPOSITORY = new InjectionToken<IOnboardingRepository>(
  'OnboardingRepository'
);

export interface IBusinessUpdateInfoPayload {
  //================= ADDITIONAL BUSINESS DATA/INFO =====================

  products?: OnboardingBusinessConfigServicesDataProps;

  schedule?: OnboardingBusinessConfigScheduleDataProps;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  schedule_notes?: string;

  notificationOptions?: ConfigNotificationsDataProps;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  payment_methods?: OnboardingBusinessConfigPaymentsDataProps;
}

export type UpdateMetaPayloadProps =
  | { [key in keyof IBusinessMetaKeys]?: boolean }
  | { SUBSCRIPTION_TYPE: 'BASIC' | 'ADVANCED' };

export interface IBusinessMetaKeys {
  USER_HAS_GMB_ACCOUNT: boolean;
  GMB_CREATE_OR_SYNC: boolean;
  BUSINESS_REGISTRATION: boolean;
  BUSINESS_CONFIG_SERVICES: boolean;
  BUSINESS_CONFIG_SCHEDULE: boolean;
  BUSINESS_CONFIG_PAYMENTS: boolean;
  BUSINESS_CONFIG_SOCIAL: boolean;
  BUSINESS_CONFIG_GMB_STATUS: boolean;
  BUSINESS_CONFIG_NOTIFICATIONS: boolean;
  BUSINESS_CONFIG_WEBSITE: boolean;
  BUSINESS_CONFIG_EXTERNAL_WEBSITE: boolean;
  SUBSCRIPTION_TYPE: 'BASIC' | 'ADVANCED';
}

export interface IImageFormProps {
  image: string;
  container: string;
  index?: number;
}

export interface IRatingAppProps {
  calificacion: number;
  descripcion: string;
}

export interface ITokenEcwid {
  bId: number; 
  businessId: number;
}
